import createMetadataAPITypes from '../../utils/api-metadata-types';
import moment from 'moment';

const options = {
  name: 'contractStatistics',
  baseType: 'CONTRACT_STATISTICS',
  apiEndpoint: 'users/{id}/contract_statistics'
};

const types = createMetadataAPITypes(options);

import createMetadataAPIReducer from '../../utils/api-metadata-reducer';

const initialState = {
  byId: {},
  ids: [],
  lastError: null,
  error: null,
  lastFetch: null,
  loading: false
};

// Example structure:
//
// {
//  byId: {
//    432: { // contract id
//      stats: {
//        'quarter_hour': [list of contract stats with distinct start times]
//        'month_shift': [list of contract stats with distinct start times]
//      }
//    }
// }

const calculateContractStatsKey = contract => `${contract.period_type}_${contract.time_unit}`;

const defaultReducer = createMetadataAPIReducer({
  baseType: 'CONTRACT_STATISTICS'
});

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SUCCESS: {
      let newById = { ...state.byId };
      for (const contract of action.payload.data) {
        const key = calculateContractStatsKey(contract);

        // all contract stats for the contract
        const oldContractStats = (newById[contract.id] || {}).stats || {};
        // all constract stats for the the same period_type and time_unit
        const oldContractStatsForPeriodAndUnit = oldContractStats[key] || [];

        const newContractStatsForPeriodAndUnit = [
          ...oldContractStatsForPeriodAndUnit.filter(s => s.start_time !== contract.start_time),
          contract
        ];

        const newContractStats = {
          ...oldContractStats,
          [key]: newContractStatsForPeriodAndUnit
        };

        const newContract = {
          user_id: contract.user_id,
          stats: newContractStats,
          loaded: true
        };

        newById = { ...newById, [contract.id]: newContract };
      }

      return { ...state, byId: newById, lastFetch: moment().format() };
    }
    default: {
      return defaultReducer(state, action);
    }
  }
};
